export const structures = [
    {
      "id": 1,
      "nom": "Orange Mali",
      "type": "Entreprise",
      "adresse": "Bamako, Mali",
      "telephone": "+223 20 12 34 56",
      "email": "contact@orange.mali",
      logo: "https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png",
      "financement": [
        {
          "id": 1,
          "typeCarte": "Adulte",
          "montant": 1000000,
          "nombreCartes": 100
        },
        {
          "id": 2,
          "typeCarte": "Mineur",
          "montant": 500000,
          "nombreCartes": 50
        }
      ]
    },
    {
      "id": 2,
      "nom": "Ministère de la Santé",
      "type": "Administration",
      "adresse": "Bamako, Mali",
      "telephone": "+223 20 12 34 56",
      "email": "contact@ministere-sante.mali",
      logo: "https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png",
      "financement": [
        {
          "id": 1,
          "typeCarte": "Adulte",
          "montant": 500000,
          "nombreCartes": 50
        },
        {
          "id": 2,
          "typeCarte": "Mineur",
          "montant": 250000,
          "nombreCartes": 25
        }
      ]
    },
    {
      "id": 3,
      "nom": "Société des Télécommunications du Mali",
      "type": "Entreprise",
      "adresse": "Bamako, Mali",
      "telephone": "+223 20 12 34 56",
      "email": "contact@stm.mali",
      logo: "https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png",
      "financement": [
        {
          "id": 1,
          "typeCarte": "Adulte",
          "montant": 750000,
          "nombreCartes": 75
        },
        {
          "id": 2,
          "typeCarte": "Mineur",
          "montant": 375000,
          "nombreCartes": 37
        }
      ]
    },
    {
      "id": 4,
      "nom": "Banque de Développement du Mali",
      "type": "Banque",
      "adresse": "Bamako, Mali",
      "telephone": "+223 20 12 34 56",
      "email": "contact@bdm.mali",
      logo: "https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png",
      "financement": [
        {
          "id": 1,
          "typeCarte": "Adulte",
          "montant": 1000000,
          "nombreCartes": 100
        },
        {
          "id": 2,
          "typeCarte": "Mineur",
          "montant": 500000,
          "nombreCartes": 50
        }
      ]
    },
    {
      "id": 5,
      "nom": "Ministère de l'Éducation",
      "type": "Administration",
      "adresse": "Bamako, Mali",
      "telephone": "+223 20 12 34 56",
      "email": "contact@ministere-education.mali",
      logo: "https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png",
      "financement": [
        {
          "id": 1,
          "typeCarte": "Adulte",
          "montant": 500000,
          "nombreCartes": 50
        }
      ]
    },
    {
      "id": 6,
      "nom": "Société des Eaux du Mali",
      "type": "Entreprise",
      "adresse": "Bamako, Mali",
      "telephone": "+223 20 12 34 56",
      "email": "contact@sem.mali",
      logo: "https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png",
      "financement": [
        {
          "id": 1,
          "typeCarte": "Adulte",
          "montant": 750000,
          "nombreCartes": 75
        },
        {
          "id": 2,
          "typeCarte": "Mineur",
          "montant": 375000,
          "nombreCartes": 37
        }
      ]
    },
    {
      "id": 7,
      "nom": "Ministère de la Sécurité",
      "type": "Administration",
      "adresse": "Bamako, Mali",
      "telephone": "+223 20 12 34 56",
      "email": "contact@ministere-securite.mali",
      logo: "https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png",
      "financement": [
        {
          "id": 1,
          "typeCarte": "Adulte",
          "montant": 600000,
          "nombreCartes": 60
        }
      ]
    }
  ]